/**
 * Google ile giriş — istemci tarafı.
 *
 * Google'ın betiği (GIS) sayfaya sonradan ve bir kere ekleniyor:
 * girişe gelmeyen kimse onu indirmiyor.
 *
 * Buradan çıkan `credential`, Google'ın imzaladığı kimlik jetonudur.
 * Ona doğrudan güvenilmiyor; sunucuya gönderiliyor ve imzası orada
 * doğrulanıyor (apps/api/src/lib/google.ts).
 */

export const GOOGLE_ISTEMCI_ID =
  '664519057761-poe9ftac4m8s37hm664c78s4a70ucf1i.apps.googleusercontent.com';

const BETIK = 'https://accounts.google.com/gsi/client';

let sozu: Promise<void> | null = null;

export function googleyiYukle(): Promise<void> {
  if (sozu) return sozu;
  sozu = new Promise((coz, red) => {
    if (document.querySelector(`script[src="${BETIK}"]`)) return coz();
    const s = document.createElement('script');
    s.src = BETIK;
    s.async = true;
    s.defer = true;
    s.onload = () => coz();
    s.onerror = () => red(new Error('Google giriş betiği yüklenemedi'));
    document.head.appendChild(s);
  });
  return sozu;
}

interface GoogleCevap {
  credential?: string;
}

/**
 * Verilen kaba Google'ın kendi düğmesini çizer.
 * `sonra` geri çağrısı kimlik jetonuyla çağrılır.
 */
export async function googleDugmesiCiz(
  kap: HTMLElement,
  sonra: (credential: string) => void,
): Promise<void> {
  await googleyiYukle();
  const g = (window as any).google;
  if (!g?.accounts?.id) throw new Error('Google giriş hazır değil');

  g.accounts.id.initialize({
    client_id: GOOGLE_ISTEMCI_ID,
    callback: (cevap: GoogleCevap) => {
      if (cevap?.credential) sonra(cevap.credential);
    },
    /* FedCM: Chrome üçüncü taraf çerezleri kapattığında One Tap'in
       çalışmaya devam etmesi için gerekli. */
    use_fedcm_for_prompt: true,
  });

  kap.innerHTML = '';
  g.accounts.id.renderButton(kap, {
    theme: 'outline',
    size: 'large',
    shape: 'pill',
    text: 'continue_with',
    locale: 'tr',
    width: Math.min(Math.max(kap.clientWidth || 280, 240), 400),
  });
}
